import { BUSCAR_FECHAMENTO_CAIXA, SELECIONAR_FECHAMENTO_CAIXA } from '../../actions/types'

const initialState = undefined
const itemInicial = { totais: {} }

export default function reducerFechamentoCaixa (state = itemInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_FECHAMENTO_CAIXA: {
      return action.payload;
    }

    case BUSCAR_FECHAMENTO_CAIXA: {
      return action.payload.data;
    }

    default: {
      return state
    }
  }
}
